module.exports = __webpack_public_path__ + "static/media/cfo_image.3f31305c.png";


//////////////////
// WEBPACK FOOTER
// ./src/presentation/assets/img/cfo_image.png
// module id = 492
// module chunks = 0